module.exports = __webpack_public_path__ + "img/twitter-light.d0bd7282.svg";